<template>
    <div class="promotionBox">
        <div class="search">
            <el-select v-model="dataStatusLabel" placeholder="状态" @focus="Select('state')" style="width: 40%;">
            </el-select>
            <el-select v-model="showStatusLabel" placeholder="是否显示" @focus="Select('look')" style="width: 40%;">
            </el-select>
        </div>
        <div class="buttons">
            <el-button size="default" icon="el-icon-plus" @click="add">新增促销</el-button>
        </div>
        <div class="cardList">
            <el-card shadow="always" v-for="(item, index) in PromotionList" :key="index">
                <div slot="header">
                    <div class="headerTitle">
                        {{ item.name }}
                    </div>
                    <div class="info">
                        <div>
                            <span>促销满足金额</span>
                            <span>{{ item.totalAmount }}</span>
                        </div>
                        <div>
                            <span>赠送金额</span>
                            <span>{{ item.giftAmount }}</span>
                        </div>
                        <div>
                            <span>状态</span>
                            <span>{{ dataStatus[item.dataStatus].dataStatus }}</span>
                        </div>
                        <div>
                            <span>是否显示</span>
                            <span>{{ showStatus[item.showStatus].showStatus }}</span>
                        </div>
                        <div>
                            <span>创建时间</span>
                            <span>{{ item.createTime }}</span>
                        </div>
                    </div>
                </div>
                <!-- card body -->
                <div class="cardBody">
                    <el-button type="primary" size="default" @click="edit(item)">编辑</el-button>
                    <el-button type="primary" size="default" @click="del(item.id)">删除</el-button>
                </div>
            </el-card>
            <div v-show="nolist" class="nolist">
                <span class="iconfont icon-charging"></span>
                <p>暂无订单记录</p>
            </div>
        </div>
        <nut-picker :is-visible="isVisible" :list-data="activeListData" @close="closeSwitch()"
            @confirm="confirm"></nut-picker>
    </div>
</template>
<script>
import { getPromotionList,delPromotion  } from '@/api/newApi'
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import { showStatus, dataStatus} from '@/dictionary/dictionary'
export default {
    data() {
        return {
            form: {
                dataStatus: "",
                showStatus: "",
                pageNo: 1,
                pageSize: 10
            },
            showStatus: showStatus,
            dataStatus: dataStatus,
            PromotionList: [],
            nolist: true,
            token: "",
            refreshing: false,
            loaded_all: false,
            loading: false,
            isVisible: false,
            activeListData: [],
            listData: [
                [
                    {
                        label: "0",
                        type: "state",
                        value: "正常"
                    },
                    {
                        label: "1",
                        type: "state",
                        value: "禁用"
                    }
                ]
            ],
            listData2: [
                [
                    {
                        label: "1",
                        type: "look",
                        value: "不显示"
                    },
                    {
                        label: "0",
                        type: "look",
                        value: "显示"
                    }
                ]
            ],
            dataStatusLabel: "",
            showStatusLabel: ""
        }
    },
    mounted() {
        this.getList()
    },
    watch: {
        PromotionList: function (v) {
            if (v == "") {
                this.nolist = true;
            } else {
                this.nolist = false;
            }
        }
    },
    methods: {
        getList() {
            getPromotionList({
                ...
                this.form
            }).then((res) => {
                console.log(res);
                this.PromotionList = res.data.records
                this.nolist = false;
                if (res.data.pages == 1) {
                    Toast("已加载全部数据");
                    this.loaded_all = true;
                }
                this.refreshing = false;
            }).catch((res) => {
                console.log(res);
            })
        },
        Select(type) {
            this.isVisible = true
            if (type == "state") {
                this.activeListData = this.listData
            } else {
                this.activeListData = this.listData2
            }
        },
        closeSwitch() {
            this.isVisible = false
        },
        confirm(event) {
            if (event[0].type == "state") {
                this.form.dataStatus = event[0].label
                this.dataStatusLabel = event[0].value
            } else {
                this.form.showStatus = event[0].label
                this.showStatusLabel = event[0].value
            }
            this.getList()
            this.isVisible = false
        },
        load() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.from.pageSize += 3;
                this.getList();
            }, 2000);
        },
        refresh() {
            this.refreshing = true;
            this.$refs.container.scrollTop = 0;
            setTimeout(() => {
                this.refreshing = false;
                this.getList();
            }, 2000);
        },
        add() {
            this.$router.push(
                {
                    path: '/admin/addPromotion'
                }
            )
        },
        del(id) {
            delPromotion(id).then(res => {
                if (res.message.status) {
                    Toast('删除成功')
                    this.getList();
                }
            })
        },
        edit(item) {
            this.$router.push(
                {
                    path: "/admin/addPromotion",
                    query: item
                }
            )
        }
    },
}
</script>
<style lang="scss" scoped>
@import"@/assets/sass/state.scss";

.promotionBox {
    padding: .4167rem;

    .search {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    ::v-deep .el-card {
        margin: .4167rem 0;
    }

    .buttons {
        margin-top: .4167rem;
    }

    .headerTitle {
        color: #fff;
        font-size: .4444rem;
    }

    .info {
        >div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            color: #7E85A7;
        }
    }

    .cardBody {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        ::v-deep .el-button {
            width: 40%;
        }
    }

    ::v-deep .el-input__inner {
        background-color: #0D1A3C;
        border-color: transparent;
        color: #A2BDE1;
    }

    ::v-deep .nut-picker {
        background-color: transparent;
    }

    ::v-deep .nut-picker-cancel-btn {
        color: #A2BDE1;
    }

    ::v-deep .nut-picker-confirm-btn {
        color: #A2BDE1;
    }

    ::v-deep .nut-picker-list .nut-picker-content,
    ::v-deep .nut-picker-list .nut-picker-item {
        background-color: #0D1A3C !important;
        color: #fff;
    }
}
</style>